<div mat-dialog-title class="text-center mb-0 fw-bold mt-3">
    <mat-icon class="w-25" style="height: 50px;" [svgIcon]="callBackIcon"></mat-icon>
</div>

<mat-divider></mat-divider>

<mat-dialog-content>
    <div class="container-fluid p-2" [formGroup]="callBackSettingsForm">
        <div class="row">
            <mat-form-field class="w-100" appearance="outline">
                <mat-label>Set the condition when the user should be called back on an inbound call</mat-label>
                <input matInput placeholder="Set the condition when the user should be called back on an inbound call"
                    formControlName="condition">    
            </mat-form-field>
        </div>
    </div>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions class="d-flex mt-1 justify-content-around">
    <button mat-dialog-close mat-raised-button class="w-25" [disabled]="isLoading" color="warn">Close</button>
    <button mat-raised-button class="w-25" [disabled]="isLoading|| !callBackSettingsForm.valid" (click)="onSubmit()"
        color="primary">
        <span *ngIf="!isLoading">
            Save
        </span>
        <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3" class="mx-auto mat-spinner"></mat-spinner>
    </button>
</mat-dialog-actions>